import { useContext, useMemo } from 'react';

import { CustomTable } from '@/shared/components';

import { ParticipantsContext } from '../ParticipantsSection/ParticipantsContext';

import { getColumnsData } from './helpers';

export const ParticipantsList = () => {
  const {
    filters,
    setFilters,
    pagination: currentPagination,
    setPagination,
    participantsTableData,
  } = useContext(ParticipantsContext);

  const columns = useMemo(() => getColumnsData({ filters }), [filters]);

  return (
    <CustomTable
      columns={columns}
      pagination={{
        total: currentPagination?.total,
        pageSize: currentPagination?.pageSize,
        current: currentPagination?.current,
      }}
      rowKey="id"
      onChange={(pagination, filters, _, extra) => {
        setFilters(filters);
        setPagination({
          ...pagination,
          ...(extra.action === 'paginate' && pagination.pageSize !== currentPagination?.pageSize ? { current: 1 } : {}),
        });
      }}
      dataSource={participantsTableData}
    />
  );
};
